import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0; 
    color: ${(props: any) => props.theme.secondary};
    font-family: Poppins;
    background-color: ${(props: any) => props.theme.primary};
  }
`;
